(function (ws) {
    'use strict';
    ws.models.accessSynnexCountryCheckModel = Backbone.Model.extend({
        urlRoot: function () {
            return globals.path.api.westcon.accessSynnexCountryCheckURL
                .replace('{countryIsocode}', this.get('countryIsocode'));
        },

        checkSynnexRedirectRequirement: function () {
            this.fetch().done((response) => {
                //If response is true, we are reloading the page
                if (response) {
                    location.reload();
                }
            }).fail(() => {
                this.error = false;
            });
        }
    });
})(westcon);
